import { render } from "./DedicatedVLANTab.vue?vue&type=template&id=b6b9a2d0&scoped=true"
import script from "./DedicatedVLANTab.vue?vue&type=script&lang=js"
export * from "./DedicatedVLANTab.vue?vue&type=script&lang=js"

import "./DedicatedVLANTab.vue?vue&type=style&index=0&id=b6b9a2d0&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b9a2d0"]])

export default __exports__